import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { cookieKey, enCookieKey } from '../assets/Constants';
export const LOGIN_COOKIE_EXPIRY_TIME = 1430;

export const getStorageKeyData = key => {
  const cookie = document.cookie;
  const cookieValue = get(cookie, key);
  if (!isEmpty(cookieValue)) {
    return cookieValue;
  } else {
    return localStorage.getItem(key) || '';
  }
};

export const setStorageKeyData = (key, value) => {
  localStorage.setItem(key, value);
  document.cookie = key + '=' + value + ';';
};

export const createSharedSession = () => {
  const enCookieValue = localStorage.getItem(enCookieKey);
  const saCookieValue = localStorage.getItem(cookieKey);
  if (enCookieValue && enCookieValue !== saCookieValue) {
    // Reset sa_t
    localStorage.setItem(cookieKey, enCookieValue);
    document.cookie = cookieKey + '=' + enCookieValue + ';';
  } else if (!enCookieValue && saCookieValue) {
    // Create en_t
    localStorage.setItem(enCookieKey, saCookieValue);
    document.cookie = enCookieKey + '=' + saCookieValue + ';';
  }
};

export const updateCurrentUserSession = tokenValue => {
  localStorage.setItem(cookieKey, tokenValue);
  document.cookie = cookieKey + '=' + tokenValue + ';';
};

export const checkSharedSession = () => {
  const enCookieValue = localStorage.getItem(enCookieKey);
  if (enCookieValue) {
    createSharedSession();
    return 'success';
  }
  return '';
};
